// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { CardTokens } from './type';

const cardTokens: CardTokens = {
  cardBackgroundColor: 'Neutral-fill-1',
  cardShadow: 'Shadow-2',
  cardHoverShadow: 'Shadow-2',
  cardBorderWidth: 'Border-1',
  cardBorderColor: 'Neutral-border-1',
  cardBorderRadius: 'Radius-default',
  cardFontColor: 'Neutral-text-5',
  cardFontSize: 'Font-14',
  cardPaddingX: 'Spacing-12',
  cardPaddingY: 'Spacing-12',
  cardTitleFontColor: 'Neutral-text-5',
  cardTitleFontSize: 'Font-16',
  cardTitleFontWeight: 'Weight-medium',
  cardHeaderGap: '8px',
  cardHeaderExtraMarginX: 'Spacing-12',
  cardHeaderPaddingX: 'Spacing-12',
  cardHeaderPaddingY: 'Spacing-12',
  cardIndicatorSize: 'Size-7',
  cardIndicatorColor: 'Neutral-text-4',
  cardBodyPaddingX: 'Spacing-12',
  cardBodyPaddingY: 'Spacing-12',
  cardBodyFontSize: 'Font-14',
  cardBodyFontColor: 'Neutral-text-5',
  cardBodyFontWeight: 'Weight-regular',
  cardBodyBorderColor: 'Neutral-border-1',
  cardFooterPaddingX: 'Spacing-12',
  cardFooterPaddingY: 'Spacing-12',
  cardFooterBorderColor: 'Neutral-border-1',
};

export default cardTokens;
